import { AllyBase } from "../base";
import { AllyObject } from "../ally-object.class";
import { AllyElementBase } from "./ally-element-base.class";

/**
 * --- This class provides part of the function matrix created by the AllyElements object. ---
 * 
 * This class creates pseudo connections in the DOM by changing AllyObject["parentObject"] and/or AllyObject["childObjects"].
 * 
 * This has the purpose to connect hovering menus like drop-down menus with their triggering element via the DOM.
 * 
 * @extends AllyElementBase
 * @see AllyElements
 */
export class AllyMenuElement extends AllyElementBase {
    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(bridge: () => AllyBase) {
        super(bridge, (matrix) => {
            matrix[0].push(
                (scope) => {
                    if (scope.self.library.angular.isMenuRoot(scope.self.node)) {
                        let self = scope.self;
                        scope.self.attributeListeners.push(() => {
                            let object: AllyObject|null|undefined = self.getObjectByNode(self.library.angular.getSubMenu(self.node));
                            if (object) {
                                if (!self.variables.subMenu) {
                                    self.variables.subMenu = object;
                                    const linked = object;
                                    const domParent = linked.parentObject;
                                    // The panel also stays in its pane's child list.
                                    linked.destroyer.addCallback(() => {
                                        const index = domParent?.childObjects.indexOf(linked) ?? -1;
                                        if (index !== -1) {
                                            domParent?.childObjects.splice(index, 1);
                                        }
                                    });
                                    linked.parentObject = self;
                                    self.childObjects.push(object);
                                    if (self.variables.hostId && object.node.parentNode && object.node.parentNode.setAttribute) {
                                        object.node.parentNode.setAttribute(self.variables.hostId, "");
                                    }
                                    object.run({self: self, root: true}, {start: {x: 1}, end: {x: 1}});
                                }
                            } else {
                                object = self.variables.subMenu;
                                if (object) {
                                    let index = self.childObjects.indexOf(object);
                                    if (index !== -1) {
                                        self.childObjects.splice(index, 1);
                                    }
                                }
                                self.variables.subMenu = undefined;
                            }
                        });
                    }
                }
            );
        }, 2);
    }
}